const SenecFlagGbUkmUnitedKingdom = () => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" role="img">
        <rect width={24} height={24} fill="white" />
        <g clipPath="url(#senec__clip0_433_29003)">
            <path fillRule="evenodd" clipRule="evenodd" d="M2 4V19H22V4H2Z" fill="#2E42A5" />
            <mask
                id="senec__mask0_433_29003"
                style={{
                    maskType: "luminance",
                }}
                maskUnits="userSpaceOnUse"
                x={2}
                y={4}
                width={20}
                height={15}
            >
                <path fillRule="evenodd" clipRule="evenodd" d="M2 4V19H22V4H2Z" fill="white" />
            </mask>
            <g mask="url(#senec__mask0_433_29003)">
                <path
                    d="M-0.226562 17.9284L4.17449 19.7897L22.1003 6.02366L24.4217 3.25773L19.7154 2.63564L12.4039 8.56781L6.51893 12.5647L-0.226562 17.9284Z"
                    fill="white"
                />
                <path d="M0.375977 19.2325L2.61811 20.3126L23.5881 3.00078H20.4399L0.375977 19.2325Z" fill="#F50100" />
                <path
                    d="M24.2271 17.9284L19.826 19.7897L1.90022 6.02366L-0.421236 3.25773L4.28506 2.63564L11.5966 8.56781L17.4816 12.5647L24.2271 17.9284Z"
                    fill="white"
                />
                <path
                    d="M24.0767 18.8643L21.8345 19.9445L12.9053 12.5324L10.2579 11.7042L-0.644833 3.26723H2.50339L13.4 11.504L16.2944 12.497L24.0767 18.8643Z"
                    fill="#F50100"
                />
                <mask id="senec__path-9-inside-1_433_29003" fill="white">
                    <path d="M14.3613 9H23.2676V14H14.3613V20.25H9.63965V14H0.767578V9H9.63965V2.75H14.3613V9Z" />
                </mask>
                <path d="M14.3613 9H23.2676V14H14.3613V20.25H9.63965V14H0.767578V9H9.63965V2.75H14.3613V9Z" fill="#F50100" />
                <path
                    d="M14.3613 9H13.1113V10.25H14.3613V9ZM23.2676 9H24.5176V7.75H23.2676V9ZM23.2676 14V15.25H24.5176V14H23.2676ZM14.3613 14V12.75H13.1113V14H14.3613ZM14.3613 20.25V21.5H15.6113V20.25H14.3613ZM9.63965 20.25H8.38965V21.5H9.63965V20.25ZM9.63965 14H10.8896V12.75H9.63965V14ZM0.767578 14H-0.482422V15.25H0.767578V14ZM0.767578 9V7.75H-0.482422V9H0.767578ZM9.63965 9V10.25H10.8896V9H9.63965ZM9.63965 2.75V1.5H8.38965V2.75H9.63965ZM14.3613 2.75H15.6113V1.5H14.3613V2.75ZM14.3613 9V10.25H23.2676V9V7.75H14.3613V9ZM23.2676 9H22.0176V14H23.2676H24.5176V9H23.2676ZM23.2676 14V12.75H14.3613V14V15.25H23.2676V14ZM14.3613 14H13.1113V20.25H14.3613H15.6113V14H14.3613ZM14.3613 20.25V19H9.63965V20.25V21.5H14.3613V20.25ZM9.63965 20.25H10.8896V14H9.63965H8.38965V20.25H9.63965ZM9.63965 14V12.75H0.767578V14V15.25H9.63965V14ZM0.767578 14H2.01758V9H0.767578H-0.482422V14H0.767578ZM0.767578 9V10.25H9.63965V9V7.75H0.767578V9ZM9.63965 9H10.8896V2.75H9.63965H8.38965V9H9.63965ZM9.63965 2.75V4H14.3613V2.75V1.5H9.63965V2.75ZM14.3613 2.75H13.1113V9H14.3613H15.6113V2.75H14.3613Z"
                    fill="white"
                    mask="url(#senec__path-9-inside-1_433_29003)"
                />
            </g>
        </g>
        <rect x={2.5} y={4.5} width={19} height={14} rx={1.5} stroke="black" strokeOpacity={0.08} />
        <defs>
            <clipPath id="senec__clip0_433_29003">
                <rect x={2} y={4} width={20} height={15} rx={2} fill="white" />
            </clipPath>
        </defs>
    </svg>
);
export default SenecFlagGbUkmUnitedKingdom;
